import styled from "styled-components";

export const SimpleMessageDialogContentBox = styled.div`
    display: flex;
    flex-direction: column;   
    text-align: center;
    flex-grow: 1;
    width: 100%;
    font-size: 1.5rem;
    color: ${props => props.theme.colors.text};
    white-space: pre-line;
`